// The sound sheets, opened from anywhere (a row's menu, the player bar)
// and drawn once by SoundSheetsHost:
//   details    components/sounds/SoundDetailsSheet.vue   (W3)
//   buy        components/PurchaseDialog.vue             (W3)
//   setPrice   components/library/SetPriceSheet.vue      (W3b)
//   editDetails components/library/EditSoundSheet.vue    (W3b)
//   rename     components/library/RenameSoundDialog.vue  (W3b)
//
// open(kind, sound, { sounds }): `sound` is a kit/sound.js Sound; `sounds`
// is Set price's multi-selection ([sound] otherwise). Every sheet's `done`
// (the updated Sounds) is re-emitted to onChange listeners, so open lists
// patch their rows.
import { reactive } from "vue";

export const SOUND_SHEETS = ["details", "buy", "setPrice", "editDetails", "rename"];

export const soundSheetState = reactive({ kind: null, sound: null, sounds: [], seq: 0 });

const listeners = new Set();

export function open(kind, sound, { sounds = null } = {}) {
  if (!SOUND_SHEETS.includes(kind) || !sound) return;
  soundSheetState.kind = kind;
  soundSheetState.sound = sound;
  soundSheetState.sounds = Array.isArray(sounds) && sounds.length ? sounds : [sound];
  soundSheetState.seq += 1;
}

export function close() {
  soundSheetState.kind = null;
}

// Listen for changed sounds; returns the unsubscribe function.
export function onChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function emitChange(updated) {
  const list = Array.isArray(updated) ? updated.filter(Boolean) : [];
  if (!list.length) return;
  for (const fn of [...listeners]) {
    try {
      fn(list);
    } catch (e) {
      console.error("soundSheets listener failed", e);
    }
  }
}

export const soundSheets = { open, close, onChange, emitChange, state: soundSheetState };
export default soundSheets;
